import { render, staticRenderFns } from "./session-list.vue?vue&type=template&id=a5cd7e8a&scoped=true&"
import script from "./session-list.vue?vue&type=script&lang=ts&"
export * from "./session-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cd7e8a",
  null
  
)

export default component.exports